import {BasketSection, BasketTitle} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {BasketInfoSkeleton} from '../BasketInfo/BasketInfo.skeleton';
import {UnavailableProductsSkeleton} from '../UnavailableProducts/UnavailableProducts.skeleton';

export const BasketPageSkeletonMobile = () => {
  return (
    <>
      <StyledBasketSection>
        <BasketTitle />
      </StyledBasketSection>
      <UnavailableProductsSkeleton />
      <BasketInfoSkeleton />
    </>
  );
};

const StyledBasketSection = styled(BasketSection)`
  padding: 0 1rem;
`;
